import { proxy } from 'valtio';
export const boleStock_store = proxy({
    conditions: 'default',
    userLastFocusSymbol: 'TSEA',
    crossType: 'golden',
    crossDays: 1,
    /** 是否有跳轉頁面行為 */
    changePage: false,
});
